"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
function default_1() {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "subtitle3 required_emphasis" }, { children: t('아래 리스트 중 택1') })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "bulleted body1 gray-80" }, { children: t('공간 대여 계약서') })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "bulleted body1 gray-80" }, { children: t('견적서') }))] }));
}
exports.default = default_1;
